export default function NoClientSelected({ entity = 'datos' }) {
  return (
    <div className="card flex flex-col items-center justify-center py-16 text-center">
      <div className="text-5xl mb-4 opacity-20">◎</div>
      <h3 className="font-medium text-slate-300 text-lg">Seleccioná un cliente para continuar</h3>
      <p className="text-slate-500 text-sm mt-2 max-w-xs">
        Los {entity} se gestionan por cliente. Elegí uno desde el selector del header.
      </p>
      <p className="text-xs text-slate-600 mt-4">▲ header → selector de cliente</p>
    </div>
  );
}
